var $c950e4b1c482abde$exports = {};
$c950e4b1c482abde$exports = {
    "alpha": `Alfa`,
    "blue": `M\u{117}lyna`,
    "brightness": `Ry\u{161}kumas`,
    "green": `\u{17D}alia`,
    "hue": `Atspalvis`,
    "lightness": `\u{160}viesumas`,
    "red": `Raudona`,
    "saturation": `\u{12E}sotinimas`
};


export {$c950e4b1c482abde$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
